import React, { Fragment } from "react";
import SweetAlertBase from "../../../../ui/sweetalert/SweetAlertBase";
import SVG from "react-inlinesvg";
import checkSVG from "../../../../../assets/svg/ils/ils-question.svg";

class SA_CancelEvaluation extends SweetAlertBase {

    config = {
        confirmButtonText: 'Don\'t Cancel',
        showCancelButton: true,
        cancelButtonText: 'Cancel Evaluation',
        reverseButtons: true
    }

    setHtml = (data) => {
        return (
            <Fragment>
                <div className="reject-scouting-alert">
                    <SVG src={checkSVG} />
                    <h2>Cancel Evaluation?</h2>
                    <p>Are you sure to cancel the evaluation? You have to start form beginning if you cancel evaluation</p>
                </div>
            </Fragment>
        )
    }

    type() {
        return 'sm';
    }

    className() {
        return "save-scouting-modal reject-scouting";
    }

    confirmButtonClasses() {
        return "reject-scouting-done btn btn-primary btn-lg btn-block mb-3";
    }

    cancelButtonClasses() {
        return "reject-scouting-done btn btn-secondary btn-lg btn-block mb-3";
    }
};

export default SA_CancelEvaluation;